module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"hd-text-1":"Tietosuoja","hd-text-2":"Tietoa evästeistä","hd-text-3":"Anna palautetta"},"se":{"hd-text-1":"Dataskydd","hd-text-2":"Information om webbkakor","hd-text-3":"Ge respons"},"en":{"hd-text-1":"Privacy","hd-text-2":"About cookies","hd-text-3":"Give feedback"}}')
  delete Component.options._Ctor
}
